import clsx from "clsx"
import { FC, memo } from "react"
import { Trans, useTranslation } from "react-i18next"
import { ICardPlayedLog } from "@/store/apis/gameplayAPI"
import styles from "./LogCardPlayed.module.scss"

const LogCardPlayedComponent: FC<ICardPlayedLog> = (props) => {
  const { t } = useTranslation("cards")

  return (
    <span className={clsx(styles.LogEffectApplied)}>
      <Trans
        i18nKey="logs.playedCard"
        values={{ name: t(`card.${props.details.cardType}.title.accusative`) }}
        components={{ span: <span className="blue" /> }}
      />
    </span>
  )
}

export const LogCardPlayed = memo(LogCardPlayedComponent)
